import { Row } from 'antd'
import React from 'react'
import MacroDetails from './MacroDetails'

const CompositionDetail = ({ productbase, detail }) => {
    return (
        <div className="Composition">
            <h6 className="font-weight-bolder mb-6">
                {productbase === "FEED_SUPPLEMENT"
                    ? ""
                    : "Composition"}
            </h6>
            <Row gutter={[12, 12]}>
                <MacroDetails type={productbase === "FEED_SUPPLEMENT" ? "composition" : "macro"} productbase={productbase} detail={detail}/>
                <MacroDetails type={productbase === "FEED_SUPPLEMENT" ? "activeIngredients" : "micro"} productbase={productbase} detail={detail}/>
            </Row>
        </div>
    )
}

export default CompositionDetail